import React from 'react';

const colors = [
  "#f9a825", // Training - orange
  "#ec407a", // Promociones - pink
  "#ffd600", // Recursos - yellow
  "#1976d2", // Mi Calendario - blue
  "#7e57c2", // Mis Objetivos - purple
  "#009688", // Agregar contacto - teal
  "#00AC46", // Agendar Demo - green
  "#ec407a", // Noticias - pink
  "#ffd200", // Mis Compensaciones - yellow
  "#f9a825", // Canales de comunicación - orange
];

const icons = [
  "/assets/img/icons/ribbon_white_spaced_25.png",  // Training
  "/assets/img/icons/cupon_ryg_23_white.png",      // Promociones
  "/assets/img/icons/recursos_white_25.png",       // Recursos
  "/assets/img/icons/calendar_white_23.png",       // Mi Calendario
  "/assets/img/icons/objetivos_white_23.png",      // Mis Objetivos
  "/assets/img/icons/newcontact_white_23.png",     // Agregar contacto
  "/assets/img/icons/agregar_white_23.png",        // Agendar demo
  "/assets/img/icons/noticias_white_25.png",        // Noticias
  "/assets/img/icons/compensaciones_white_26.png", // Mis Compensaciones
  "/assets/img/icons/directory_white_26.png",      // Canales de comunicación
];

export default function HomeMenu() {
  const handleClick = (path, titleToolbar) => {
    window.localStorage.setItem('titleToolbar', titleToolbar);
    window.location.href = path;
  };

  return (
    <div style={{maxWidth: 400, margin: "0 auto"}}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gridTemplateRows: "repeat(5, 1fr)",
          gap: 8,
        }}
      >
        {/* Training */}
        <div
          onClick={() => handleClick("/training", "Training")}
          style={{
            cursor: "pointer",
            background: colors[0],
            color: "#fff",
            borderRadius: "0 0 60px 0",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            padding: 16,
            paddingTop: 4,
            minHeight: 110,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            textDecoration: "none",
            gridRow: "1 / 2",
            gridColumn: "1 / 2",
          }}
        >
          <div>
            <h2 style={{fontSize: 18, fontWeight: "bold", marginBottom: 4}}>Training</h2>
            <p style={{fontSize: 13}}>Capacítate y haz crecer tu negocio</p>
          </div>
          <div style={{display: "flex", justifyContent: "flex-end", paddingBottom: 8}}>
            <img src={icons[0]} alt="Training" style={{width: 32, height: 32}} />
          </div>
        </div>

        {/* Promociones */}
        <div
          onClick={() => handleClick("/promociones", "Promociones")}
          style={{
            cursor: "pointer",
            background: colors[1],
            color: "#fff",
            borderRadius: "0 0 60px 0",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            padding: 16,
            paddingTop: 4,
            minHeight: 110,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            textDecoration: "none",
            gridRow: "1 / 2",
            gridColumn: "2 / 3",
          }}
        >
          <div>
            <h2 style={{fontSize: 18, fontWeight: "bold", marginBottom: 4}}>Promociones</h2>
            <p style={{fontSize: 13}}>Para clientes, presentadores y ofertas tienda en línea</p>
          </div>
          <div style={{display: "flex", justifyContent: "flex-end", paddingBottom: 8}}>
            <img src={icons[1]} alt="Promociones" style={{width: 32, height: 32}} />
          </div>
        </div>

        {/* Recursos */}
        <div
          onClick={() => handleClick("/recursos", "Recursos")}
          style={{
            cursor: "pointer",
            background: colors[2],
            color: "#fff",
            borderRadius: "0 0 60px 0",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            padding: 16,
            paddingTop: 4,
            minHeight: 110,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            textDecoration: "none",
            gridRow: "2 / 3",
            gridColumn: "1 / 2",
          }}
        >
          <div>
            <h2 style={{fontSize: 18, fontWeight: "bold", marginBottom: 4}}>Recursos</h2>
            <p style={{fontSize: 13}}>Descargables, fichas y guías.</p>
          </div>
          <div style={{display: "flex", justifyContent: "flex-end", paddingBottom: 8}}>
            <img src={icons[2]} alt="Recursos" style={{width: 32, height: 32}} />
          </div>
        </div>

        {/* Mi Calendario */}
        <div
          onClick={() => handleClick("/calendario", "Calendario")}
          style={{
            cursor: "pointer",
            background: colors[3],
            color: "#fff",
            borderRadius: "0 0 60px 0",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            padding: 16,
            paddingTop: 4,
            minHeight: 110,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            textDecoration: "none",
            gridRow: "2 / 3",
            gridColumn: "2 / 3",
          }}
        >
          <div>
            <h2 style={{fontSize: 18, fontWeight: "bold", marginBottom: 4}}>Mi Calendario</h2>
            <p style={{fontSize: 13}}>Consulta tus demos, entregas y capacitaciones en vivo</p>
          </div>
          <div style={{display: "flex", justifyContent: "flex-end", paddingBottom: 8}}>
            <img src={icons[3]} alt="Mi Calendario" style={{width: 32, height: 32}} />
          </div>
        </div>

        {/* Agregar contacto */}
        <div
          onClick={() => handleClick("/directorio", "Directorio")} //GIANADEV TODO: cambiar a /nuevo-contacto abriendo ventana para agregar contacto
          style={{
            cursor: "pointer",
            background: colors[5],
            color: "#fff",
            borderRadius: "0 0 60px 0",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            padding: 16,
            paddingTop: 4,
            minHeight: 110,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            textDecoration: "none",
            gridRow: "3 / 4",
            gridColumn: "1 / 2",
          }}
        >
          <div>
            <h2 style={{fontSize: 18, fontWeight: "bold", marginBottom: 4}}>Agregar contacto</h2>
            <p style={{fontSize: 13}}>Añade nuevos contactos a tu directorio</p>
          </div>
          <div style={{display: "flex", justifyContent: "flex-end", paddingBottom: 8}}>
            <img src={icons[5]} alt="Agregar contacto" style={{width: 32, height: 32}} />
          </div>
        </div>

        {/* Agendar Demo */}
        <div
          onClick={() => handleClick("/calendario", "Calendario")} //GIANADEV TODO: cambiar a /agendar-demo abriendo ventana para agendar demo
          style={{
            cursor: "pointer",
            background: colors[6],
            color: "#fff",
            borderRadius: "0 0 60px 0",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            padding: 16,
            paddingTop: 4,
            minHeight: 110,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            textDecoration: "none",
            gridRow: "3 / 4",
            gridColumn: "2 / 3",
          }}
        >
          <div>
            <h2 style={{fontSize: 18, fontWeight: "bold", marginBottom: 4}}>Agendar Demo</h2>
            <p style={{fontSize: 13}}>Programa una demostración de productos</p>
          </div>
          <div style={{display: "flex", justifyContent: "flex-end", paddingBottom: 8}}>
            <img src={icons[6]} alt="Agendar Demo" style={{width: 32, height: 32}} />
          </div>
        </div>

        {/* Mis Objetivos */}
        <div
          onClick={() => handleClick("/objetivos", "Objetivos")}
          style={{
            cursor: "pointer",
            background: colors[4],
            color: "#fff",
            borderRadius: "0 0 60px 0",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            padding: 16,
            paddingTop: 4,
            minHeight: 110,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            textDecoration: "none",
            gridRow: "4 / 5",
            gridColumn: "1 / 2",
          }}
        >
          <div>
            <h2 style={{fontSize: 18, fontWeight: "bold", marginBottom: 4}}>Mis Objetivos</h2>
            <p style={{fontSize: 13}}>¿Qué quieres lograr? ¿Cuáles son tus ratios para alcanzarlo?</p>
          </div>
          <div style={{display: "flex", justifyContent: "flex-end", paddingBottom: 8}}>
            <img src={icons[4]} alt="Mis Objetivos" style={{width: 32, height: 32}} />
          </div>
        </div>

        {/* Noticias */}
        <div
          onClick={() => window.open("https://docs.google.com/presentation/d/1zmq_3OnvIbbSXDixjgQZzvfIm4aIw-fe/edit?usp=sharing&ouid=112873258297503966038&rtpof=true&sd=true", "_blank")}
          style={{
            cursor: "pointer",
            background: colors[7],
            color: "#fff",
            borderRadius: "0 0 60px 0",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            padding: 16,
            paddingTop: 4,
            minHeight: 110,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            textDecoration: "none",
            gridRow: "4 / 5",
            gridColumn: "2 / 3",
          }}
        >
          <div>
            <h2 style={{fontSize: 18, fontWeight: "bold", marginBottom: 4}}>Noticias</h2>
            <p style={{fontSize: 13}}>Mantente actualizado con las últimas novedades</p>
          </div>
          <div style={{display: "flex", justifyContent: "flex-end", paddingBottom: 8}}>
            <img src={icons[7]} alt="Noticias" style={{width: 32, height: 32}} />
          </div>
        </div>

        {/* Canales de comunicación */}
        <div
          onClick={() => handleClick("/compensaciones", "Mis Compensaciones")}
          style={{
            cursor: "pointer",
            background: colors[8],
            color: "#fff",
            borderRadius: "0 0 60px 0",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            padding: 16,
            paddingTop: 4,
            minHeight: 110,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            textDecoration: "none",
            gridRow: "5 / 6",
            gridColumn: "1 / 2",
          }}
        >
          <div>
            <h2 style={{fontSize: 18, fontWeight: "bold", marginBottom: 4}}>Mis Compensaciones</h2>
            <p style={{fontSize: 13}}>Descarga tus resúmenes por mes.</p>
          </div>
          <div style={{display: "flex", justifyContent: "flex-end", paddingBottom: 8}}>
            <img src={icons[8]} alt="Mis Compensaciones" style={{width: 32, height: 32}} />
          </div>
        </div>

        {/* Canales de comunicación */}
        <div
          onClick={() => handleClick("/canales", "Canales de comunicación")}
          style={{
            cursor: "pointer",
            background: colors[9],
            color: "#fff",
            borderRadius: "0 0 60px 0",
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            padding: 16,
            paddingTop: 4,
            minHeight: 110,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            textDecoration: "none",
            gridRow: "5 / 6",
            gridColumn: "2 / 3",
          }}
        >
          <div>
            <h2 style={{fontSize: 18, fontWeight: "bold", marginBottom: 4}}>Canales de comunicación</h2>
            <p style={{fontSize: 13}}>Utilizar el canal adecuado garantiza que tu solicitud sea atendida.</p>
          </div>
          <div style={{display: "flex", justifyContent: "flex-end", paddingBottom: 8}}>
            <img src={icons[9]} alt="Canales de comunicación" style={{width: 32, height: 32}} />
          </div>
        </div>
      </div>
    </div>
  );
}